<template>
	<view class="index">
		<view class="list">
			<view class="list-item">
				<view class="list-item-label">
					<view class="list-item-label-x"></view>
					<text>时间地点</text>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">用工时间<b>*</b></view>
					<view class="list-item-row-val">
						<text>请选择</text>
						<u-icon name="arrow-right" color="#111111" size="16"></u-icon>
					</view>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">用工地点<b>*</b></view>
					<view class="list-item-row-val">
						<text>请选择</text>
						<u-icon name="arrow-right" color="#111111" size="16"></u-icon>
					</view>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">地点描述</view>
					<view class="list-item-row-val">
						<input type="text" placeholder="请输入" />
					</view>
				</view>
			</view>
			<view class="list-item">
				<view class="list-item-label">
					<view class="list-item-label-x"></view>
					<text>需求</text>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">采摘品种<b>*</b></view>
					<view class="list-item-row-val">
						<text>请选择</text>
						<u-icon name="arrow-right" color="#111111" size="16"></u-icon>
					</view>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">采摘重量<b>*</b></view>
					<view class="list-item-row-val">
						<text>请选择</text>
						<u-icon name="arrow-right" color="#111111" size="16"></u-icon>
					</view>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">需求补充</view>
					<view class="list-item-row-val">
						<textarea cols="30" rows="10" placeholder="请输入" maxlength="200"></textarea>
					</view>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">图片</view>
					<view class="list-item-row-upload">
						<view class="upload-item">
							<image src="/static/logo.png" mode="widthFix"></image>
						</view>
						<view class="upload-item">
							<u-icon name="plus" color="#999999" size="24"></u-icon>
							<text>点击上传</text>
						</view>
					</view>
				</view>
				<view class="list-item-zk">
					<text>补充需求</text>
					<u-icon name="arrow-down" color="#00BC12" size="16"></u-icon>
				</view>
			</view>
			<view class="list-item">
				<view class="list-item-label">
					<view class="list-item-label-x"></view>
					<text>费用</text>
				</view>
				<view class="list-item-row">
					<view class="list-item-row-label">费用标准<b>*</b></view>
					<view class="list-item-row-val">
						<input type="text" placeholder="请输入" />
						<text>元/斤</text>
					</view>
				</view>
			</view>
		</view>
		<view style="width: 100%; height: calc(214rpx + env(safe-area-inset-bottom));"></view>
		<view class="footer">
			<view class="footer-price">
				<view class="footer-price-info">预估总费用</view>
				<view class="footer-price-num">
					<text>0</text>
					<text>元</text>
				</view>
			</view>
			<view class="footer-bottom">
				<div class="footer-bottom-btn">
					<text>立即下单</text>
					<text>（服务完成后付款）</text>
				</div>
			</view>
			<view style="width: 100%; height: env(safe-area-inset-bottom);"></view>
		</view>
	</view>
</template>

<script>
	export default {
		data() {
			return {
				
			};
		}
	}
</script>

<style>
	page {
		background-color: #F7F7F7 !important;
	}
</style>

<style lang="scss" scoped>
	.index {
		width: 100%;
		.footer {
			width: 100%;
			height: calc(214rpx + env(safe-area-inset-bottom));
			padding: 20rpx 30rpx;
			box-sizing: border-box;
			position: fixed;
			bottom: 0;
			left: 0;
			z-index: 9;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			background: #FFFFFF;
			box-shadow: 0rpx -2rpx 4rpx 0rpx rgba(0,0,0,0.06);
			.footer-price {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.footer-price-info {
					font-weight: 400;
					font-size: 30rpx;
					color: #222222;
				}
				.footer-price-num {
					display: flex;
					align-items: center;
					text {
						&:nth-child(1) {
							font-weight: 500;
							font-size: 40rpx;
							color: #FF0000;
							margin-right: 20rpx;
						}
						&:nth-child(2) {
							font-weight: 400;
							font-size: 30rpx;
							color: #222222;
						}
					}
				}
			}
			.footer-bottom {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;
				.footer-bottom-kf {
					flex-shrink: 0;
					margin-right: 40rpx;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					image {
						width: 36rpx;
						height: 36rpx;
					}
					text {
						font-weight: 400;
						font-size: 24rpx;
						color: #222222;
						margin-top: 8rpx;
					}
				}
				.footer-bottom-btn {
					flex: 1;
					height: 88rpx;
					display: flex;
					align-items: center;
					justify-content: center;
					background: #00BC12;
					box-shadow: 0rpx 8rpx 12rpx 0rpx rgba(91,190,56,0.16);
					border-radius: 44rpx;
					text {
						&:nth-child(1) {
							font-weight: 500;
							font-size: 32rpx;
							color: #FFFFFF;
						}
						&:nth-child(2) {
							font-weight: 500;
							font-size: 26rpx;
							color: #FFFFFF;
						}
					}
				}
			}
		}
		.list {
			width: 100%;
			display: flex;
			flex-direction: column;
			.list-item {
				width: 100%;
				padding: 40rpx 30rpx;
				box-sizing: border-box;
				background-color: #ffffff;
				border-radius: 20rpx;
				margin-bottom: 20rpx;
				&:last-child {
					margin: 0 !important;
				}
				.list-item-label {
					display: flex;
					align-items: center;
					margin-bottom: 28rpx;
					text {
						font-weight: 600;
						font-size: 32rpx;
						color: #222222;
					}
					.list-item-label-x {
						width: 6rpx;
						height: 30rpx;
						background: #00BC12;
						border-radius: 4rpx;
						margin-right: 20rpx;
					}
				}
				.list-item-zk {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
					text {
						font-weight: 400;
						font-size: 28rpx;
						color: #00BC12;
						margin-right: 8rpx;
					}
				}
				.list-item-row {
					width: 100%;
					display: flex;
					flex-direction: column;
					border-bottom: 1rpx solid #E5E5E5;
					margin-bottom: 30rpx;
					&:last-child {
						margin: 0 !important;
					}
					.list-item-row-label {
						font-weight: 400;
						font-size: 28rpx;
						color: #666666;
						display: flex;
						align-items: center;
						b {
							color: red;
						}
					}
					.list-item-row-user {
						width: 100%;
						display: flex;
						flex-direction: column;
						.user-item {
							width: 100%;
							padding: 30rpx 0;
							box-sizing: border-box;
							display: flex;
							align-items: center;
							margin-bottom: 30rpx;
							justify-content: space-between;
							border-bottom: 1rpx solid #E5E5E5;
							&:last-child {
								margin: 0 !important;
							}
							text {
								flex-shrink: 0;
								font-weight: 400;
								font-size: 30rpx;
								color: #333333;
							}
							input {
								flex: 1;
								text-align: center;
								margin: 0 30rpx;
								font-weight: 400;
								font-size: 30rpx;
								color: #222222;
							}
						}
					}
					.list-item-row-radio {
						width: 100%;
						display: flex;
						padding: 30rpx 0;
						box-sizing: border-box;
						flex-direction: column;
						border-bottom: 1rpx solid #E5E5E5;
						.radio-item {
							width: 100%;
							display: flex;
							align-items: center;
							margin-bottom: 30rpx;
							&:last-child {
								margin: 0 !important;
							}
							.radio-item-label {
								width: 200rpx;
								flex-shrink: 0;
								font-weight: 400;
								font-size: 30rpx;
								color: #111111;
							}
							.radio-item-list {
								flex: 1;
								display: flex;
								flex-direction: column;
								.radio-item-list-l {
									width: 100%;
									display: flex;
									align-items: center;
									.active {
										background: #00BC12 !important;
										color: #ffffff !important;
									}
									.radio-item-list-item {
										width: 124rpx;
										height: 72rpx;
										line-height: 72rpx;
										text-align: center;
										background: #EEEEEE;
										border-radius: 36rpx;
										font-weight: 400;
										font-size: 28rpx;
										color: #111111;
										margin-right: 30rpx;
										&:last-child {
											margin: 0 !important;
										}
									}
								}
								.radio-item-list-data {
									width: 100%;
									display: flex;
									align-items: center;
									justify-content: flex-end;
									margin-top: 42rpx;
									text {
										font-weight: 400;
										font-size: 30rpx;
										color: #333333;
									}
									input {
										width: 100rpx;
										font-weight: bold;
										font-size: 30rpx;
										color: #222222;
										text-align: right;
										margin: 0 30rpx;
									}
								}
							}
						}
					}
					.list-item-row-upload {
						width: 100%;
						display: flex;
						align-items: center;
						flex-wrap: wrap;
						padding: 30rpx 0;
						box-sizing: border-box;
						.upload-item {
							width: 156rpx;
							height: 156rpx;
							display: flex;
							align-items: center;
							flex-direction: column;
							justify-content: center;
							background: #F8F9FB;
							border-radius: 8rpx;
							margin-right: 20rpx;
							border: 2rpx solid #EEEEEE;
							&:last-child {
								margin: 0 !important;
							}
							image {
								width: 100%;
							}
							text {
								font-weight: 400;
								font-size: 26rpx;
								color: #666666;
								margin-top: 16rpx;
							}
						}
					}
					.list-item-row-val {
						width: 100%;
						padding: 30rpx 0;
						box-sizing: border-box;
						display: flex;
						align-items: center;
						justify-content: space-between;
						text {
							flex-shrink: 0;
							font-weight: 400;
							font-size: 30rpx;
							color: #111111;
						}
						input {
							width: 100%;
							font-weight: 400;
							font-size: 30rpx;
							color: #222222;
						}
						textarea {
							width: 100%;
							height: 90rpx;
							font-weight: 400;
							font-size: 30rpx;
							color: #111111;
						}
					}
				}
			}
		}
	}
</style>
